













































































import Vue from "vue";
import MonatsuebersichtPopover, { MonatseinnahmenVerschiebenEvent } from "./MonatsuebersichtPopover.vue";
import MonatsuebersichtContextMenu, { MenuItemSelected } from "./MonatsuebersichtContextMenu.vue";
import { default as moment, Moment } from "moment-timezone";
import { forkJoin, of, Observable } from "rxjs";
import { flatMap, groupBy, map, mergeMap, reduce, switchMap, toArray } from "rxjs/operators";
import { Studio } from "@/api/Studio";
import { currentTimestamp, PopoverMode, sortStringsAlnum, TIMEZONE } from "@/api/Termine";
import { AbrechnungTag, Ausgabe, Einnahme, Kassenbuch, Transaktion } from "@/api/Abrechnung";
import { getStudioKuerzel } from "@/api/http";
import { format } from "@/api/reporting/util";

type WochenStudio = { studios: { [studio: string]: { summeEinnahmen: number; summeSteuer: number } }; summeAusgaben: number };
type WochenStudios = { [tag: number]: WochenStudio };
type SummeStudioeinnahmen = { [studio: string]: { summeEinnahmen: number; summeSteuer: number } };
type Differenzen = { [target: string]: number }[];

export default Vue.extend({
  name: "Monatsuebersicht",
  components: {
    MonatsuebersichtContextMenu,
    MonatsuebersichtPopover,
  },
  props: {
    monat: {
      type: Number,
      required: true,
    },
    jahr: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      zeit: currentTimestamp(),
      studios: [] as Studio[],
      wochenStudios: {} as WochenStudios,
      summeStudioeinnahmen: {} as SummeStudioeinnahmen,
      summeAusgaben: 0,
      differenzen: [] as Differenzen,
    };
  },
  created() {
    this.zeit = currentTimestamp();
  },
  mounted() {
    this.zeit.month(this.monat).year(this.jahr);
    this.updateData();
  },
  watch: {
    monat() {
      console.log('Neuer Monat:', this.monat);
      this.zeit.month(this.monat);
      this.updateData();
    },
    jahr() {
      console.log('Neues Jahr:', this.jahr);
      this.zeit.year(this.jahr);
      this.updateData();
    },
  },
  computed: {
    monatFormatiert(): string {
      this.monat; // Hack to trigger re-evaluation, see https://logaretm.com/blog/2019-10-11-forcing-recomputation-of-computed-properties
      return this.zeit.format("YYYY-MM");
    },
  },
  methods: {
    getLetztenTagDerWoche(tag: number) {
      const wochenIndex = Math.floor((tag - 1) / 7);
      let letzterTag;
      if (wochenIndex <= 3) {
        letzterTag = wochenIndex * 7 + 7;
      } else {
        letzterTag = moment(this.zeit).daysInMonth();
      }
      //console.log(`${tag} => ${letzterTag}`)
      return letzterTag;
    },
    updateData() {
      this.$store.dispatch("appLoading", true);

      this.studios = (this.$store.getters["studios"] as Studio[]).sort((a, b) => a.nummernkreis - b.nummernkreis);
      //const studioSort = {'Gi-Gu': 1, 'DA': 2, 'GG': 3, 'WI': 4} as {[studio: string]: number};
      const studioSort = this.studios.reduce((agg, cur) => { agg[getStudioKuerzel(cur.bezeichner)] = cur.nummernkreis; return agg; }, {} as {[studio: string]: number});


      const _this = this as any;
      forkJoin(
        this.$znaApi.getKassenbuch(this.zeit),
        this.$znaApi.getKassenbuchEinnahmen(this.zeit).pipe(
          flatMap(monatsabschluesse => {
            return monatsabschluesse
              .flatMap(monatsabschluss => {
                const studioId = parseInt((monatsabschluss.monat_studio as string).substring(8));
                const studio = getStudioKuerzel(this.studios.filter(studio => studio.id == studioId)[0].bezeichner);
                return (monatsabschluss.tage as AbrechnungTag[]).map(einnahme => ({
                    studio: studio,
                    tag: parseInt(einnahme.buchungstag),
                    einnahme: einnahme.miete + (einnahme.manuelleAnpassung || 0),
                    steuer: einnahme.steuer,
                  } as Einnahme));
              });
            }),
          toArray(),
        ),
      ).pipe(
        mergeMap(([kassenbuch, einnahmen]) => {
          const anzahlTage = moment().tz(TIMEZONE).year(this.jahr).month(this.monat).date(15).daysInMonth();
          const summeStudioeinnahmen: SummeStudioeinnahmen = {};
          const wochenStudios: WochenStudios = {};
          for (let tag = 1; tag < anzahlTage; tag += 7) {
            const wochenStudio: WochenStudio = { studios: {}, summeAusgaben: 0 };
            this.studios.forEach(studio => {
              const kuerzel = getStudioKuerzel(studio.bezeichner);
              wochenStudio.studios[kuerzel] = { summeEinnahmen: 0, summeSteuer: 0, };
              if (!(kuerzel in summeStudioeinnahmen)) {
                summeStudioeinnahmen[kuerzel] = { summeEinnahmen: 0, summeSteuer: 0, };
              }
            });
            wochenStudios[this.getLetztenTagDerWoche(tag)] = wochenStudio;
          }
          einnahmen.forEach(einnahme => {
            const studioTag = wochenStudios[this.getLetztenTagDerWoche(einnahme.tag)].studios[einnahme.studio];
            studioTag.summeEinnahmen += einnahme.einnahme;
            studioTag.summeSteuer += einnahme.steuer;
            summeStudioeinnahmen[einnahme.studio].summeEinnahmen += einnahme.einnahme;
            summeStudioeinnahmen[einnahme.studio].summeSteuer += einnahme.steuer;
          });
          let summeAusgaben = 0;
          kassenbuch.ausgaben.forEach(ausgabe => {
            console.log(ausgabe, this.getLetztenTagDerWoche(ausgabe.tag));
            const studioTag = wochenStudios[this.getLetztenTagDerWoche(ausgabe.tag)];
            studioTag.summeAusgaben += ausgabe.betrag;
            summeAusgaben += ausgabe.betrag;
          });
          return forkJoin(
            of(kassenbuch),
            of(wochenStudios),
            of(summeStudioeinnahmen),
            of(summeAusgaben),
          );
        }),
      ).subscribe(([kassenbuch, wochenStudios, summeStudioeinnahmen, summeAusgaben]) => {
        this.wochenStudios = wochenStudios;
        this.summeStudioeinnahmen = summeStudioeinnahmen;
        this.summeAusgaben = summeAusgaben;
        const differenzen = [] as Differenzen;
        for (let y = 0; y < this.studios.length - 1; y++) {
          differenzen.push({});
          const zeile = differenzen[y];
          for (let x = 0; x < this.studios.length; x++) {
            const studioKuerzel1 = getStudioKuerzel(this.studios[x].bezeichner);
            const studioKuerzel2 = getStudioKuerzel(this.studios[(y + x + 1) % this.studios.length].bezeichner);
            zeile[studioKuerzel2] = summeStudioeinnahmen[studioKuerzel1].summeEinnahmen - summeStudioeinnahmen[studioKuerzel2].summeEinnahmen;
          }
        }
        this.differenzen = differenzen;
        console.log(wochenStudios);
        console.log(summeStudioeinnahmen);
        console.log(summeAusgaben);
        console.log(differenzen);
        this.$store.dispatch("appLoading", false);
      },
      this.handleRestError);
    },
    format(betrag: number, printZeros = false): string {
      return format(betrag, printZeros, 2);
    },
    openContextMenu(sourceStudio: string) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        const e = event as MouseEvent;
        const targetStudios = this.studios.map(s => getStudioKuerzel(s.bezeichner)).filter(s => s != sourceStudio);
        const contextMenu = this.$refs.contextMenu as any;
        contextMenu.open(sourceStudio, targetStudios);
      }
    },
    onMenuItemSelected(selectedEvent: MenuItemSelected) {
      this.showDialog(selectedEvent.sourceStudio, selectedEvent.targetStudio);
    },
    showDialog(sourceStudio: string, targetStudio: string) {
      const popover: any = this.$refs.popover;
      const diffBetrag = this.summeStudioeinnahmen[sourceStudio].summeEinnahmen - this.summeStudioeinnahmen[targetStudio].summeEinnahmen;
      const verschiebeBetrag = Math.round(diffBetrag / 2);
      const betrag = Math.max(verschiebeBetrag, 0);
      this.$nextTick(() => popover.show(sourceStudio, targetStudio, betrag));
    },
    betragVerschieben(verschiebenEvent: MonatseinnahmenVerschiebenEvent) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      console.log(verschiebenEvent);

      if (verschiebenEvent) {
        this.$store.dispatch("appLoading", true);
        const studios: { [kuerzel: string]: Studio } = this.studios.reduce((agg: any, studio: Studio) => { agg[getStudioKuerzel(studio.bezeichner)] = studio; return agg; }, {});
        const sourceStudio = studios[verschiebenEvent.sourceStudio];
        const targetStudio = studios[verschiebenEvent.targetStudio];
        this.$znaApi.monatseinnahmenVerschieben(this.zeit, sourceStudio, targetStudio, verschiebenEvent.betrag).subscribe(
          _ => {
          this.$toast.add({
            severity: "success",
            summary: "Verschieben erfolgreich",
            detail: `Erfolgreich ${verschiebenEvent.betrag} € von ${getStudioKuerzel(verschiebenEvent.sourceStudio)} nach ${getStudioKuerzel(verschiebenEvent.targetStudio)} verschoben`,
            life: 3000,
          });
          this.updateData();
        },
          this.handleRestError
        );
      }
    },
    handleRestError(error: any) {
      error = error && error.message ? error.message : error;
      this.$toast.add({
        severity: "error",
        summary: "Laden der Daten fehlgeschlagen",
        detail: error,
        life: 3000,
      });
      this.$store.dispatch("appLoading", false);
    }
  },
});
